/**@jsx jsx */
import { css, jsx } from '@emotion/core'
import { IconButton } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CloseIcon from '@material-ui/icons/Close';


const Alert = (props) => {

    const { alertType, setIsAlertOpen } = props;

    const successAlertContainer = css`
    left: 0;
    top: 0;
    align-self: center;
    position: absolute;
    width: 25%;
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background: #75ff7578;
    border-radius: 5px;
    .MuiIconButton-root {
        color: #005d00;
        :hover {
            background-color: #00000030;
        }
    }
    `;

    const errorAlertContainer = css`
    left: 0;
    top: 0;
    align-self: center;
    position: absolute;
    width: 25%;
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background: #fb36368c;
    border-radius: 5px;
    .MuiIconButton-root {
        color: #840000;
        :hover {
            background-color: #00000030;
        }
    }
    `;

    const successIconTextContainer = css`
    align-items: center;
    display: flex;
    .MuiSvgIcon-root {
        color: #005d00;
    }
    `;

    const errorIconTextContainer = css`
    align-items: center;
    display: flex;
    .MuiSvgIcon-root {
        color: #840000;
    }
    `;

    const textStyle = css`
    margin-right: 10px;
    font-weight: bold;
    `;

    return (
        <div css={alertType === 'success' ? successAlertContainer : errorAlertContainer}>
            <div css={alertType === 'success' ? successIconTextContainer : errorIconTextContainer}>
                {alertType === 'success' ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}
                {alertType === 'success' ? <div css={textStyle}>המייל נשלח בהצלחה!</div> : <div css={textStyle}>אירעה שגיאה, נסה שוב</div>}
            </div>
            <IconButton
                onClick={() => setIsAlertOpen(false)}
            >
                <CloseIcon />
            </IconButton>
        </div>
    );
}

export default Alert;
